import { OxySelector } from "@/oxygen/classes/lib/types";

export function mergeSelectors(
  existingSelectors: OxySelector[],
  selectorsToMerge: OxySelector[],
  propToMerge: "id" | "name" = "name",
  mergeChildren = true,
  reuseIds = true
) {
  const newSelectorsByProp = selectorsToMerge.map(
    selector => selector[propToMerge]
  );

  const selectorsToKeep = existingSelectors.filter(
    selector => !newSelectorsByProp.includes(selector[propToMerge])
  );

  const newSelectors = selectorsToMerge.map(selector => {
    const existingSelector = existingSelectors.find(
      existingSelector =>
        existingSelector[propToMerge] === selector[propToMerge]
    );

    // Keep the ID of the existing selector if it exists.
    // If a selector is already in use, we want to keep its ID to avoid breaking references.
    if (existingSelector && reuseIds) {
      selector.id = existingSelector.id;
    }

    if (selector.children && mergeChildren) {
      if (existingSelector && existingSelector.children) {
        const existingChildrenByProp = existingSelector.children.map(
          child => child[propToMerge]
        );

        const newChildren = selector.children.filter(
          child => !existingChildrenByProp.includes(child[propToMerge])
        );

        return {
          ...selector,
          children: [...existingSelector.children, ...newChildren]
        };
      }
    }

    return selector;
  });

  return {
    selectorsToKeep,
    selectors: [...selectorsToKeep, ...newSelectors]
  };
}
